'use client';

import React, { useState } from 'react';
import { useRouter } from 'next/router';
import Button from 'app/components/Button';

export default function LeavePreviewButton() {
  const { reload } = useRouter();
  const [isClearingPreviewData, setIsClearingPreviewData] = useState(false);
  const leavePreviewMode = async () => {
    setIsClearingPreviewData(true);
    try {
      await fetch(`${process.env.NEXT_PUBLIC_BASE_PATH}/api/clear-preview-data`);
      reload();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
    } finally {
      setIsClearingPreviewData(false);
    }
  };

  return (
    <Button
      type="button"
      classes="fixed -rotate-90 top-1/2 z-50 translate-y-1/2 origin-top-left tracking-wide"
      onClick={leavePreviewMode}
      disabled={isClearingPreviewData}
    >
      Leave preview mode
    </Button>
  );
}
